'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slate = require('slate');

/**
 * Clear the content of the given cell
 */
function clearCell(opts, change, cell) {
    cell.nodes.forEach(function (node, index) {
        var range = _slate.Range.create().moveToRangeOf(cell);
        change.deleteAtRange(range);
    });

    return change;
}
exports.default = clearCell;